import { render } from "./AvatarImage.vue.js?vue&type=template&id=6a964f46!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AvatarImage.vue?vue&type=template&id=6a964f46"
import script from "./AvatarImage.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AvatarImage.vue?vue&type=script&lang=js"
export * from "./AvatarImage.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AvatarImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/AvatarImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a964f46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a964f46', __exports__)) {
    api.reload('6a964f46', __exports__)
  }
  
  module.hot.accept("./AvatarImage.vue.js?vue&type=template&id=6a964f46!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AvatarImage.vue?vue&type=template&id=6a964f46", () => {
    api.rerender('6a964f46', render)
  })

}


export default __exports__